module.exports = {
    codigodocumpersonacorp: 30,
    detalleContacto: 100,
    indTipoTributacion: 40
};